import React from 'react';
import PropTypes from 'prop-types';
import { chunk } from '../../../utils/helper-functions';
import SectionTitle from '../home-section-title';
import ADP from '../../../assets/client-logos/adp.svg';
import Firmenich from '../../../assets/client-logos/firmenich.svg';
import JohnsonJohnson from '../../../assets/client-logos/johnson-johnson.svg';
import LG from '../../../assets/client-logos/lg.svg';
import Merck from '../../../assets/client-logos/merck.svg';
import Ohaus from '../../../assets/client-logos/ohaus.svg';
import Philips from '../../../assets/client-logos/philips.svg';
import Sothebys from '../../../assets/client-logos/sothebys.svg';
import Prudential from '../../../assets/client-logos/prudential.svg';
import Centrica from '../../../assets/client-logos/centrica.svg';
import Dupont from '../../../assets/client-logos/dupont.svg';
import Priceline from '../../../assets/client-logos/priceline.svg';
import Pfitzer from '../../../assets/client-logos/pfitzer.svg';
import Bnsf from '../../../assets/client-logos/bnsf.svg';
import Ieee from '../../../assets/client-logos/ieee.svg';
import Basf from '../../../assets/client-logos/basf.svg';
import Ets from '../../../assets/client-logos/ets.svg';
import Ricoh from '../../../assets/client-logos/ricoh.svg';
import Quest from '../../../assets/client-logos/quest.svg';
import SteveMadden from '../../../assets/client-logos/steve-madden.svg';
import Reveal from '../../reveal';
import { Spring } from 'react-spring';
import * as easings from 'd3-ease';
import styles from './home-clients.module.css';

const HomeClientsContent = props => {
  const { isInView } = props;
  const settings = {
    sectionTitle: `Brands We've<br> Amplified`,
  };

  const content = [
    { logo: <Firmenich />, id: 0 },
    { logo: <JohnsonJohnson />, id: 1 },
    { logo: <ADP />, id: 2 },
    { logo: <Merck />, id: 3 },
    { logo: <Ohaus />, id: 4 },
    { logo: <Philips />, id: 5 },
    { logo: <Sothebys />, id: 6 },
    { logo: <Prudential />, id: 7 },
    { logo: <Centrica />, id: 8 },
    { logo: <Dupont />, id: 9 },
    { logo: <Pfitzer />, id: 10 },
    { logo: <Priceline />, id: 11 },
    { logo: <Ieee />, id: 12 },
    { logo: <Basf />, id: 13 },
    { logo: <Ets />, id: 14 },
    { logo: <Ricoh />, id: 15 },
    { logo: <Quest />, id: 16 },
    { logo: <SteveMadden />, id: 17 },
  ];

  const renderRows = numberOfRows => {
    const newContent = chunk(content, numberOfRows);
    const newContentLastObject = newContent.length - 1;

    const emptyPlaceholder = () => {
      const numberOfContentBlocks = newContent[newContentLastObject].length;

      if (numberOfContentBlocks < numberOfRows) {
        let emptyArr = [];
        const empty = { message: null };
        for (let i = 0; i < numberOfRows - numberOfContentBlocks; i++) {
          emptyArr.push(empty);
        }
        return [...newContent[newContentLastObject], ...emptyArr];
      }
    };

    if (newContent[newContentLastObject].length !== numberOfRows) {
      newContent[newContentLastObject] = emptyPlaceholder();
    }

    const clientRowsDelays = newContent.map((value, index) => {
      return { delay: 450 * (index + 1) };
    });

    return newContent.map((content, index) => {
      const animationConfig = {
        delay: clientRowsDelays[index].delay,
        duration: 1000,
        easing: easings.easeCubicOut,
      };
      return (
        <Spring
          key={index}
          from={{ opacity: '0' }}
          to={{
            opacity: isInView ? '1' : '0',
          }}
          config={animationConfig}
        >
          {animation => (
            <div className={styles.row} key={index} style={animation}>
              {renderContentBlocks(newContent[index], numberOfRows)}
            </div>
          )}
        </Spring>
      );
    });
  };

  const renderContent = content => {
    return <div className={styles.squareBlock}>{content.logo}</div>;
  };

  const renderContentBlocks = (content, rows) => {
    return content.map((logo, index) => {
      return (
        <div
          key={index}
          className={
            rows === 3
              ? [styles.content, styles.contentThree].join(' ')
              : rows === 6
              ? [styles.content, styles.contentSix].join(' ')
              : styles.content
          }
        >
          {renderContent(logo)}
        </div>
      );
    });
  };

  return (
    <React.Fragment>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <SectionTitle
            sectionName={settings.sectionTitle}
            isInView={isInView}
          />
          <div
            className={[styles.contentWrapper, styles.contentWrapperThree].join(
              ' '
            )}
          >
            {renderRows(3)}
          </div>
          <div
            className={[styles.contentWrapper, styles.contentWrapperSix].join(
              ' '
            )}
          >
            {renderRows(6)}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

const HomeClients = props => {
  return (
    <Reveal>
      <HomeClientsContent {...props} />
    </Reveal>
  );
};

export default HomeClients;



// WEBPACK FOOTER //
// ./src/components/home/home-clients/index.js